module.exports = "/assets/data/715b1d4236246caeb18c941d3ae46911-DE11.data.json";